import Layout from "./Layout";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import imageCompression from "browser-image-compression";

import { opById, opList } from "../api/network/api";
import messages from "../utils/messages";
import {
  TextField,
  FileFeild,
  UserCheckboxFeild,
  RadioFeild,
  PhoneComponent,
} from "./InputFeild";
import SaveButton from "../component/SaveButton";
import { toast } from "react-toastify";

const initial_data = () => {
  return {
    name: "",
    mobile: "",
    photo: "",
    gender: "",
    email: "",
    verify: "",
  };
};

function UserEdit() {
  const [userData, setUserData] = useState({});
  const [showSpinner, setShowSpinner] = useState(false);
  const [previewPhoto, setPreviewPhoto] = useState("");

  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    setShowSpinner(true);
    opById("get", `user`, params.id)
      .then((result) => {
        setUserData(result.data);
        setPreviewPhoto(result.data.photo);
      })
      .catch((error) => {
        console.log(error, "errorrrrrrrrrrrrrrrrrrrrrrrr:>>>>>>>>>>");
      })
      .finally(() => {
        setShowSpinner(false);
      });
  }, []);
  const ContactSchema = Yup.object().shape({
    name: Yup.string().required(messages.required.name),
    mobile: Yup.string().required(messages.required.phone),
    email: Yup.string().email(messages.invalidEmail),
  });
  const formik = useFormik({
    initialValues: {
      ...userData,
    },
    validationSchema: ContactSchema,

    onSubmit: (values) => {
      setShowSpinner(true);
      opById("put", `user`, params.id, values)
        .then((result) => {
          setTimeout(() => {
            setShowSpinner(false);
            toast(result.message, { type: "success" });
            navigate("/user/list");
          }, 2000);
        })
        .catch((error) => {
          setShowSpinner(false);
          console.log(error, "errorrrrrrrrrrrrrrrrrrrrrrrr:>>>>>>>>>>");
        });
    },
    enableReinitialize: true,
  });

  const setFormikPhotoValue = async (photo) => {
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        // fileType: "image/png",
      };
      const compressedFile = await imageCompression(photo, options);

      console.log(
        `compressedFile size ${compressedFile.size / 1024 / 1024} MB`
      ); // smaller than maxSizeMB
      var file = new File([compressedFile], photo.name, {
        type: photo.type,
        size: compressedFile.size,
      });
      setPreviewPhoto(URL.createObjectURL(compressedFile));

      formik.setFieldValue("photo", file);
    } catch (error) {
      console.log("error.response :>> ", error);
    }
  };
  const handelCancel = () => {
    navigate("/user/list");
  };

  return (
    <Layout
      module="user"
      title="User Edit"
      breadcrumb="Home-User's-Edit User's"
    >
      <form class="w-100">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-4">
              <label for="" class="form-label">
                Name
              </label>
              <TextField
                formik={formik}
                name="name"
                placeholder="Name"
                type="text"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <label for="" class="form-label">
                Email
              </label>
              <TextField
                formik={formik}
                name="email"
                placeholder="Email"
                type="text"
                icon
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <label for="" class="form-label">
                Photo
              </label>
              <FileFeild
                name="photo"
                formik={formik}
                setFormikPhotoValue={setFormikPhotoValue}
                previewPhoto={previewPhoto}
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <label for="" class="form-label">
                MSN
              </label>
              <PhoneComponent
                formik={formik}
                name={"mobile"}
                label={false}
                placeholder={"MSN"}
                icon={"phone"}
                type="text"
                disabled={true}
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <label for="" class="form-label">
                Verified
              </label>
              {/* <TextField
                formik={formik}
                name="verify"
                placeholder="Verified"
                disabled={true}
                type="text"
              /> */}
              <UserCheckboxFeild
                isUser={true}
                formik={formik}
                name="verify"
                disabled={true}
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <label for="" class="form-label">
                Gender
              </label>
              <RadioFeild
                formik={formik}
                radioValues="Male,Female,Other"
                name="gender"
                disabled={true}
              />
            </div>
          </div>

          <br />

          <div class="col-md-6">
            <div class="mb-3">
              <div class="d-flex align-items-center flex-wrap">
                <a
                  className="btn btn-secondary mw105 my-1 me-3"
                  onClick={handelCancel}
                  href="#"
                >
                  Cancel
                </a>
                <SaveButton
                  handleSubmit={formik.handleSubmit}
                  showSpinner={showSpinner}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </Layout>
  );
}
export default UserEdit;
